// extracted by mini-css-extract-plugin
export default {"menu__popover":"Menu_menu__popover__2jfGP"};